import { areItemsEqual } from '.';
import { GenericItem } from '../types';

export default <TItem extends GenericItem>({
  selectedItems,
  item,
}: {
  selectedItems?: TItem[];
  item: TItem;
}) =>
  selectedItems
    ? selectedItems.some((selectedItem) => areItemsEqual(selectedItem, item))
    : false;
